<template>
    <div id="menu" :class="color">
        <b-container fluid>
            <b-row>
                <b-col md="12">
                    <b-navbar toggleable="lg" type="light">
                        <b-navbar-brand href="#"><img class="logo" src="../assets/img/img_logo.png" alt=""></b-navbar-brand>

                        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                        <b-collapse id="nav-collapse" is-nav>
                            <!-- Right aligned nav items -->
                            <b-navbar-nav class="ml-auto">
                                <b-nav-item href="#about">About</b-nav-item>
                                <b-nav-item href="#brands">Brands</b-nav-item>
                                <b-nav-item href="#clients">Clients</b-nav-item>
                                <b-nav-item href="#services">Services</b-nav-item>
                                <b-nav-item href="#contact">Contact</b-nav-item>        
                            </b-navbar-nav>
                        </b-collapse>
                    </b-navbar>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {
        props: {
            color: {
                colorHead: String,
                default: 'light'
            }
        }
    }
</script>

<style scoped>
#menu{
    position: fixed;
    width: 100%;
    z-index: 999999;
}
.ml-auto{
    margin-left: auto;
}
.dark{
    background: #000;
}
.nav-link{
    color: #fff;
    font-size: 27px;
}
.nav-link:focus,
.nav-link:hover,
.nav-link:active{
    color: #fff;
}
.navbar-toggler,
.navbar-toggler:hover,
.navbar-toggler:focus,
.navbar-toggler:active{
    border: none;
    outline: 0 !important;
}
.navbar-expand-lg .navbar-nav .nav-link{
    padding-left: 30px;
    padding-right:30px;
}
@media (max-width: 1600px){
    .logo{
        width: 300px;
    }
    .nav-link{
        font-size: 23px;
    }
}
@media (max-width: 968px){
    #menu{
        background: #000;
    }
}
@media (max-width: 768px){
  .logo{
    width: 150px;
  }
}
</style>